import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {PredefinedInterval} from '../date-interval/predefined-interval';
import * as moment from 'moment';
import {MomentDateRange} from '../date-interval/moment-date-range';

@Injectable({
  providedIn: 'root'
})
export class DateIntervalService {
  momentNow = moment(new Date());
  todayStart = this.momentNow.clone().set('hours', 0).set('minutes', 0).set('second', 0);
  todayEnd = this.momentNow.clone().set('hours', 23).set('minutes', 59).set('second', 59);
  yesterdayStart = this.todayStart.clone().subtract(1, 'days');
  yesterdayEnd = this.todayEnd.clone().subtract(1, 'days');

  public intervals: Array<PredefinedInterval> = [
    {
      caption: 'Today',
      from: this.todayStart,
      to: this.todayEnd,
    },
    {
      caption: 'Yesterday',
      from: this.yesterdayStart,
      to: this.yesterdayEnd,
    },
    {
      caption: '7 days',
      from: this.momentNow.clone().subtract(7, 'days').add(1, 'seconds'),
      to: this.momentNow.clone(),
    },
    {
      caption: '30 days',
      from: this.momentNow.clone().subtract(30, 'days').add(1, 'seconds'),
      to: this.momentNow.clone(),
    },
  ];
  public dateRange: BehaviorSubject<MomentDateRange> =
    new BehaviorSubject<MomentDateRange>([this.intervals[0].from, this.intervals[0].to]);
  constructor() { }
}
